"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentRect = void 0;

function getParentRect(ref) {
  var _a, _b, _c;

  return (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) !== null && _c !== void 0 ? _c : null;
}

exports.getParentRect = getParentRect;